<template>
  <div class="custom-loading" v-if="loading">
    <Spin fix v-if="loading">
      <div class="loading-box">
        <img class="loading-img" src="https://static.getconnectplus.com/tb_webassets/tb_loading.gif" />
        <div class="loading-text">请稍候</div>
        <img class="loading-img" src="https://static.getconnectplus.com/tb_webassets/tb_loading.gif" />
      </div>
    </Spin>
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {};
  },
  props: {
    loading: {
      type: Boolean,
      default: ""
    }
  },
  components: {}
};
</script>
<style lang="less" scoped>
.part-container {
  padding-top: 3rem;
  .part {
    border-top: 0.1rem solid #eaeaea;
    padding-top: 2rem;
    padding-bottom: 2rem;
    text-align: center;
    border-bottom: none;
    span:hover {
      color: #5c5d5f;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Loading.vue